"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorCapture = exports.OVER_LIMIT_SPACE_RECORDS = exports.OVER_LIMIT_PER_SHEET_RECORDS = void 0;
const config_1 = require("../config");
const i18n_1 = require("../exports/i18n");
const types_1 = require("../types");
exports.OVER_LIMIT_PER_SHEET_RECORDS = '305';
exports.OVER_LIMIT_SPACE_RECORDS = '309';
const OVER_LIMIT_GANTT_VIEW_NUMBER = '307';
const OVER_LIMIT_CALENDAR_NUMBER = '308';
const errorCapture = () => {
    return (_target, name, descriptor) => {
        const fn = descriptor.value;
        return {
            configurable: true,
            get() {
                const boundFn = fn.bind(this);
                console.log('get function name:' + name); //不知道为什么只代理第一次，所以注释掉，不然一堆的报错，不知道哪来的
                Reflect.defineProperty(this, name, {
                    value: boundFn,
                    configurable: true,
                    writable: true,
                });
                const i18nMessage = (code, message) => {
                    switch (code) {
                        case 50000:
                            return (0, i18n_1.t)(i18n_1.Strings.socket_error_server);
                        case 50001:
                            return (0, i18n_1.t)(i18n_1.Strings.socket_error_network);
                        case config_1.StatusCode.FRONT_VERSION_ERROR:
                            return (0, i18n_1.t)(i18n_1.Strings.front_version_error_desc);
                    }
                    return message;
                };
                const getErrorType = (code) => {
                    if ([exports.OVER_LIMIT_PER_SHEET_RECORDS, exports.OVER_LIMIT_SPACE_RECORDS, OVER_LIMIT_GANTT_VIEW_NUMBER, OVER_LIMIT_CALENDAR_NUMBER].includes(code)) {
                        return 'subscribeUsage';
                    }
                    return;
                };
                const onError = (e) => {
                    const code = e.code || types_1.ErrorCode.CollaSyncError;
                    this.event.onError && this.event.onError(Object.assign(Object.assign({}, e), { type: types_1.ErrorType.CollaError, code: code, message: i18nMessage(code, e.message) }), getErrorType(code));
                    throw e;
                };
                return (...args) => {
                    try {
                        const promise = boundFn(...args);
                        // If it is a promise, you need to listen catch catch
                        if (promise instanceof Promise) {
                            promise.catch(e => {
                                onError(e);
                            });
                        }
                        return promise;
                    }
                    catch (e) {
                        onError(e);
                    }
                };
            },
        };
    };
};
exports.errorCapture = errorCapture;
//# sourceMappingURL=error_capture.js.map